// src/features/files/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import FilesPage from './pages/FilesPage';
import FileViewerPage from './pages/FileViewerPage';

// The viewer stays open to everyone: it shows files attached to tasks,
// equipment and procedures, which the API serves without file:read.
export const FileRoutes = () => (
  <>
    <Route
      path="files"
      element={
        <ProtectedRoute requiredScope="file:read">
          <FilesPage />
        </ProtectedRoute>
      }
    />
    <Route path="files/view/:fileId" element={<FileViewerPage />} />
  </>
);
